import { combineReducers, Reducer } from 'redux';

// slices
import chatReducer from 'src/features/chat/redux';
import wikiReducer from 'src/features/wiki/redux';
import profileReducer from 'src/redux/profile';
import notificationsReducer from 'src/features/notifications/redux';
import uiReducer from 'src/redux/ui';
import authReducer from 'src/features/auth/redux';
import tutorialsReducer from 'src/features/tutorials/redux';

type ProfileState = any;
type NotificationsState = any;
type UiState = any;
type TutorialsState = any;

const rootReducer = combineReducers({
  chat: chatReducer,
  wiki: wikiReducer,
  profile: profileReducer as Reducer<ProfileState>,
  notifications: notificationsReducer as Reducer<NotificationsState>,
  ui: uiReducer as Reducer<UiState>,
  auth: authReducer,
  tutorials: tutorialsReducer as Reducer<TutorialsState>
});

export { rootReducer };
